<template>
  <div>
    <descubre-hero />
    <bottom-shape :background="'rgb(100 178 226)'"></bottom-shape>
    <div class="container text-center">
      <h2 class="mt-md-5" style="font-size: 45px, line-height: 67px;">Hacemos accesible y fácil estudiar el Talmud</h2>
      <div class="row">
        <div class="col-md-4">
            <img :src="require('../assets/images/descubre-1.png')" class="img-fluid mb-3 mt-md-5 px-5 px-md-0">
            <p>Diseña tu propio <u>plan de estudio</u> con clases en video, audio o texto, con o sin conexión a Internet.</p>
        </div>
        <div class="col-md-4">
            <img :src="require('../assets/images/descubre-2.png')" class="img-fluid mb-3 mt-md-5 px-5 px-md-0">
            <p><u>Resuelve tus dudas</u> enviando tus preguntas al equipo de Rabanim, en cualquier momento.</p>
        </div>
        <div class="col-md-4">
            <img :src="require('../assets/images/descubre-3.png')" class="img-fluid mb-3 mt-md-5 px-5 px-md-0">
            <p>Regala <u>Ketarim</u> para que otros puedan estudiar y colabora con la <u>próxima versión</u> de Jabrutouch.</p>
        </div>
      </div>
    </div>
    <users/>
    <caracteristic/>
    <div class="container mb-5 text-center">
      <div class="row justify-content-md-center">
        <div class="col-md-4 justify-self-center">
          <h3>Hay más</h3>
          <p>Estamos trabajando en la próxima versión de la plataforma que revolucionará el estudio de Talmud con innovadoras herramientas.</p>
          <div class="mb-5 mt-4">
            <a href="https://play.google.com/store/apps/details?id=co.il.jabrutouch"><img :src="require('../assets/images/g-play.png')" alt=""></a>
            <a href="https://apps.apple.com/il/app/jabrutouch/id1488439011"><img :src="require('../assets/images/app-store.png')" alt=""></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DescubreHero from "./DescubreHero";
import Caracteristic from "./Caracteristic";
import Users from "./Users";
export default {
  components: {
    DescubreHero,
    Caracteristic,
    Users,
  },
  data() {
    return {
    }
  },
  methods: {
  },
};
</script>
<style lang="scss">
</style>